<template>
  <div v-intersect="handleIntersect">
    <slot />
    <slot
      v-if="hasNextPage"
      name="loading-state"
    >
      <div class="d-flex justify-center mb-4">
        <img
          alt="animated loader"
          :src="loadingImg"
        >
      </div>
    </slot>
    <slot
      v-if="!hasNextPage"
      name="no-more-data-state"
    />
  </div>
</template>

<script>
import LoadingImg from '~/assets/images/clockwise_loader.gif'

export default {
  name: 'SnInfiniteLoader',
  props: {
    hasNextPage: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      loadingImg: LoadingImg
    }
  },
  methods: {
    handleIntersect (entries, observer, isIntersecting) {
      if (isIntersecting && this.hasNextPage) {
        this.$emit('load-more')
      }
    }
  }
}
</script>
